module.exports = __webpack_public_path__ + "img/pic30.31804558.png";